<template lang="html">
<div class="goods-box goods-guide border-bottom-20">
    <div class="guide-title">购物流程</div>
    <div class="guide-img ">
        <img src="~/assets/images/common/icon_38.png" alt="">
    </div>
</div>
</template>
<script>
export default {
    name: 'guideBox'
}
</script>

<style  lang="stylus" scoped >
@import '~@/assets/stylus/variables.styl'
@import '~@/assets/stylus/mixin.styl'
.goods-box
    background white
.goods-guide
    .guide-title
      padding 30px 30px 0px 30px
      font-size $fontBase
    .guide-img
      img
        width 100%
</style>
